import ApiService from "@/api.service";
import API from "@/API";

export const GET_LIST_BRAND = "listBrand";
export const SET_LIST_BRAND = "setBrand";
export const UPDATE_BRAND = "updateBrand";
export const SAVE_BRAND = "saveBrand";
export const DELETE_BRAND = "deleteBrand";
export const UPLOAD_BRAND_IMAGE = "uploadBrand";
export const GET_DETAIL_BRAND = "getDetailBrand";
export const SET_DETAIL_BRAND = "setDetailBrand";
export const SET_LIST_BRAND_SELECT = "setDetailBrandSelect";


const state = {
    brands: [],
    brand: [],
    brandSelect :[]
};

const getters = {
    brands(state) {
        return state.brands;
    },
    brandDetail(state) {
        return state.brand;
    },
    brandSelect(state) {
        return state.brandSelect;
    }
};

const actions = {
    [GET_LIST_BRAND](context) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_LIST_BRAND}`).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_LIST_BRAND, data);
                    context.commit(SET_LIST_BRAND_SELECT, data);
                }
                resolve(data);
            });
        });
    },
    [GET_DETAIL_BRAND](context, id) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_DETAIL_BRAND}/${id}`).then(({ data }) => {
                if (data.status) {

                    context.commit(SET_DETAIL_BRAND, data);
                }
                resolve(data);
            });
        });
    },
    [SAVE_BRAND](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.SAVE_BRAND}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [UPLOAD_BRAND_IMAGE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.UPLOAD_BRAND_IMAGE}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [UPDATE_BRAND](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.update(`${API.UPDATE_BRAND}`, payload.id, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [DELETE_BRAND](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`${API.DELETE_BRAND}`,id)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

};

const mutations = {
    [SET_LIST_BRAND](state, data) {
        state.brands = data.data;
    },
    [SET_DETAIL_BRAND](state, data) {
        state.brand = data.data;
    },
    [SET_LIST_BRAND_SELECT](state, data) {
        let arr = [...data.data];
        arr.unshift({"id": "-1", "name": "Chọn tất cả"});
        state.brandSelect = arr;
    },

};

export default {
    state,
    actions,
    mutations,
    getters
};